import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import LFOComponent from 'components/lfo/LFOComponent.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'
import '../../Instruments.scss';

class InstrumentComponent extends Component {
    constructor(props) {
        super(props);
    }

    getOscillatorOptions() {
        let options = [
            {value: 'square', label:'Square'},
            {value: 'sine', label:'Sine'},
            {value: 'triangle', label:'Triangle'},
            {value: 'sawtooth', label:'Sawtooth'},
            {value: 'pwm', label:'PWM'},
            {value: 'pulse', label:'Pulse'},
        ];

        return options;
    }

    getOscillatorOption(value) {
        let options = this.getOscillatorOptions();
        for (var i=0; i < options.length; i++) {
            if (options[i].value == value) {
                return options[i];
            }
        }
        return null;
    }

    getSelectedOscillatorType() {
        return this.props.instrument.oscillatorType;
    }

    onSelectOscillatorType(o) {
        let value = o.value === 'none' ? undefined : o.value;
        this.props.instrument.oscillatorType = value;
        this.setState(this.state);
    }

    render() {
        let instrument = this.props.instrument;
        let lfo = this.props.instrument.lfos[0];
        return (
            <div className="instrument synth">
              <div className="instrument-name">
                {this.props.instrument.getName()}
             </div>
             <div className="clear-fix"/>
              <div className="instrument-section">
              <div className="instrument-subsection">
                <div className="instrument-subsection-name">
                  Oscillator
                </div>
              <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={this.getOscillatorOptions()}
                  onChange={(o) => this.onSelectOscillatorType(o)}
                  value={this.getOscillatorOption(this.getSelectedOscillatorType())}
                  placeholder="Osc. Type" />
              </div>
<div className="clear-fix"/>
                <EffectParameterSlider
                  name={'Frequency'}
                  automation={this.props.automation}
                  parameter={instrument.oscillatorFrequencyParameter}
                  onParameterChanged={() => instrument.releaseAll()}
                  displayFunction={(x) => Notes.fromTranspose(x).toString()}
                  isParameter={true}
                  min={-32}
                  max={32}
                  step={1}
                  />
                <EffectParameterSlider
                  name={'Detune'}
                  lfoEnabled={true}
                  automation={this.props.automation}
                  instrument={instrument}
                  lfos={instrument.lfos}
                  parameter={instrument.detuneParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={-100}
                  max={100}
                  step={1}
                  />
                <EffectParameterSlider
                  lfoEnabled={true}
                  lfos={instrument.lfos}
                  instrument={instrument}
                  automation={this.props.automation}
                  name={'Pulse Width'}
                  parameter={instrument.pulseWidthParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={1}
                  step={0.01}
                  />
                <EffectParameterSlider
                  name={'Polyphony'}
                  automation={this.props.automation}
                  parameter={instrument.polyphonyParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={1}
                  max={16}
                  step={1}
                  />
                <EffectParameterSlider
                  name={'Glide'}
                  automation={this.props.automation}
                  parameter={instrument.portamentoParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={50}
                  step={0.1}
                  />
              </div>
<div className="instrument-subsection">
                <div className="instrument-subsection-name">
                  Filter
                </div>
                <div className="clear-fix"/>
                <EffectParameterSlider
                  name={'Cutoff'}
                  lfoEnabled={true}
                  automation={this.props.automation}
                  lfos={instrument.lfos}
                  instrument={instrument}
                  parameter={instrument.filterCutoffParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={10000}
                  step={1}
                  />
              <EffectParameterSlider
                name={'Q'}
                lfoEnabled={true}
                automation={this.props.automation}
                lfos={instrument.lfos}
                instrument={instrument}
                parameter={instrument.filterQParameter}
                onParameterChanged={() => []}
                isParameter={true}
                min={0}
                max={9}
                step={1}
                />
              </div>
</div>
              <div className="instrument-section">
                <LFOComponent instrument={instrument}/>
                <div className="instrument-subsection">
                  <div className="instrument-subsection-name">
                    Amp Envelope
                  </div>
                  <div className="clear-fix"/>
                  <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Attack'}
                    lfoEnabled={true}
                    lfos={instrument.lfos}
                    instrument={instrument}
                    parameter={instrument.ampAttackParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={6000}
                    step={1}
                    />
                  <EffectParameterSlider
                    automation={this.props.automation}
                    name={'Amp Decay'}
                    lfoEnabled={true}
                    lfos={instrument.lfos}
                    instrument={instrument}
                    parameter={instrument.ampDecayParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={6000}
                    step={1}
                    />
                   <EffectParameterSlider
                    name={'Amp Sustain'}
                     automation={this.props.automation}
                    lfoEnabled={true}
                    lfos={instrument.lfos}
                    instrument={instrument}
                    parameter={instrument.ampSustainParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={1}
                    step={0.01}
                    />
                   <EffectParameterSlider
                    name={'Amp Release'}
                     automation={this.props.automation}
                    lfoEnabled={true}
                    lfos={instrument.lfos}
                    instrument={instrument}
                    parameter={instrument.ampReleaseParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={10000}
                    step={1}
                    />
 
                </div>
             </div>
              <div className="instrument-section">
                <EnvelopesComponent
                  automation={this.props.automation}
                  instrument={instrument}/>
              </div>
              </div>);
    }
}

class EnvelopesComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let envelope = this.props.instrument.filterEnvelope;
        return (
            <div className="instrument-subsection">
              <div className="instrument-subsection-name">
                Filter Envelope
              </div>
              <div className="clear-fix"/>
                <EffectParameterSlider
                  name={'Frequency'}
                  parameter={envelope.baseFrequencyParameter}
                  automation={this.props.automation}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={10000}
                  step={1}
                  />
                <EffectParameterSlider
                  name={'Octaves'}
                  parameter={envelope.octavesParameter}
                  automation={this.props.automation}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={8}
                  step={0.1}
                  />
                <EffectParameterSlider
                  name={'Attack'}
                  parameter={envelope.attackParameter}
                  automation={this.props.automation}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={8000}
                  step={1}
                  />
                <EffectParameterSlider
                  name={'Decay'}
                  parameter={envelope.decayParameter}
                  automation={this.props.automation}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={8000}
                  step={1}
                  />
                <EffectParameterSlider
                  name={'Sustain'}
                  parameter={envelope.sustainParameter}
                  automation={this.props.automation}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={1}
                  step={0.01}
                  />
                  <EffectParameterSlider
                  name={'Release'}
                  automation={this.props.automation}
                  parameter={envelope.releaseParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={8000}
                  step={1}
                  />
            </div>
        );
    }
}

export default InstrumentComponent;
